module.exports = __webpack_public_path__ + "static/img/mul-shop-bg.d82f9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all-versions/mul-shop-bg.png
// module id = 893
// module chunks = 2